// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/home.scss
// module id = 8
// module chunks = 0 3